import 'fancybox-core';
import 'fancybox-media';

const $fancyLinks = $('.js-fancy-link');

if ($fancyLinks.length > 0) {
  $fancyLinks.fancybox({
    maxWidth: 1000,
    maxHeight: 700,
    fitToView: false,
    width: '80%',
    height: '80%',
    autoSize: false,
    closeClick: false,
    openEffect: 'none',
    closeEffect: 'none',
  });
}
